import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUpdateAutoTests = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none",
		d: "M4.819211458333333 9.248920833333333c2.2085839583333335 -0.444 3.9867885416666664 -2.243795625 4.4314052083333335 -4.509498333333333 0.44469375 2.2657027083333334 2.2224666666666666 4.065498333333334 4.4310583333333335 4.509498333333333m0 0.00254375c-2.208591666666667 0.444 -3.98675 2.24381875 -4.431443750000001 4.509529166666667 -0.44469375 -2.265710416666667 -2.2224358333333334 -4.065529166666667 -4.431019791666667 -4.509529166666667",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		fill: "none",
		d: "M17.394547916666667 7.782410416666667c0.46180625 2.575816666666667 -0.30262916666666667 5.328385416666666 -2.29330625 7.319062499999999 -3.23171875 3.23171875 -8.471311875000001 3.23171875 -11.703007500000002 0 -3.231694854166667 -3.231641666666667 -3.231694854166667 -8.471281041666668 0 -11.702976666666668 3.2316956250000004 -3.231694083333333 8.47128875 -3.231694083333333 11.703007500000002 0l0.6769458333333334 0.6769227083333333",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none",
		d: "M12.860275 4.170331666666667h2.9596145833333334V1.2106785416666668",
		strokeWidth: 1.5
	}));
});
export default SvgUpdateAutoTests;
